// Stagiaire stagiaire STAGIAIRE 
import {
    STAGIAIRE_DETAILS_FAIL,
    STAGIAIRE_DETAILS_REQUEST,
    STAGIAIRE_DETAILS_SUCCESS,
    STAGIAIRE_LOGIN_FAIL,
    STAGIAIRE_LOGIN_REQUEST,
    STAGIAIRE_LOGIN_SUCCESS,
    STAGIAIRE_LOGOUT,
    STAGIAIRE_REGISTER_FAIL,
    STAGIAIRE_REGISTER_REQUEST,
    STAGIAIRE_REGISTER_SUCCESS,

    STAGIAIRE_ADD_FAIL,
    STAGIAIRE_ADD_REQUEST,
    STAGIAIRE_ADD_SUCCESS,

    STAGIAIRE_UPDATE_PROFILE_REQUEST,
    STAGIAIRE_UPDATE_PROFILE_SUCCESS,
    STAGIAIRE_UPDATE_PROFILE_FAIL,
    STAGIAIRE_DETAILS_RESET,
    STAGIAIRE_LIST_FAIL,
    STAGIAIRE_LIST_REQUEST,
    STAGIAIRE_LIST_SUCCESS,
    STAGIAIRE_LIST_RESET,
    STAGIAIRE_DELETE_REQUEST,
    STAGIAIRE_DELETE_SUCCESS,
    STAGIAIRE_DELETE_FAIL,
    STAGIAIRE_UPDATE_RESET,
    STAGIAIRE_UPDATE_REQUEST,
    STAGIAIRE_UPDATE_SUCCESS,
    STAGIAIRE_UPDATE_FAIL
} from "../constants/stagiaireConstants"

export const stagiaireLoginReducer = (state = {}, action) => {
    switch (action.type) {
        case STAGIAIRE_LOGIN_REQUEST:
            return { loading: true }
        case STAGIAIRE_LOGIN_SUCCESS:
            return { loading: false, stagiaireInfo: action.payload }
        case STAGIAIRE_LOGIN_FAIL:
            return { loading: false, error: action.payload }
        case STAGIAIRE_LOGOUT:
            return {}
        default:
            return state
    }
}

export const stagiaireRegisterReducer = (state = {}, action) => {
    switch (action.type) {
        case STAGIAIRE_REGISTER_REQUEST:
            return { loading: true }
        case STAGIAIRE_REGISTER_SUCCESS:
            return { loading: false, stagiaireInfo: action.payload }
        case STAGIAIRE_REGISTER_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}



export const stagiaireAddReducer = (state = {}, action) => {
    switch (action.type) {
        case STAGIAIRE_ADD_REQUEST:
            return { loading: true }
        case STAGIAIRE_ADD_SUCCESS:
            return { loading: false, stagiaireInfo: action.payload }
        case STAGIAIRE_ADD_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const stagiaireDetailsReducer = (state = { stagiaire: {} }, action) => {
    switch (action.type) {
        case STAGIAIRE_DETAILS_REQUEST:
            return { ...state, loading: true }
        case STAGIAIRE_DETAILS_SUCCESS:
            return { loading: false, stagiaire: action.payload }
        case STAGIAIRE_DETAILS_FAIL:
            return { loading: false, error: action.payload }
        case STAGIAIRE_DETAILS_RESET:
            return { stagiaire: {} }
        default:
            return state
    }
}

export const stagiaireUpdateProfileReducer = (state = {}, action) => {
    switch (action.type) {
        case STAGIAIRE_UPDATE_PROFILE_REQUEST:
            return { ...state, loading: true }
        case STAGIAIRE_UPDATE_PROFILE_SUCCESS:
            return { loading: false, success: true, stagiaireInfo: action.payload }
        case STAGIAIRE_UPDATE_PROFILE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const stagiaireListeReducer = (state = { stagiaires: [] }, action) => {
    switch (action.type) {
        case STAGIAIRE_LIST_REQUEST:
            return { loading: true }
        case STAGIAIRE_LIST_SUCCESS:
            return { loading: false, stagiaires: action.payload }
        case STAGIAIRE_LIST_FAIL:
            return { loading: false, error: action.payload }
        case STAGIAIRE_LIST_RESET:
            return { stagiaires: [] }
        default:
            return state
    }
}

export const stagiaireDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case STAGIAIRE_DELETE_REQUEST:
            return { loading: true }
        case STAGIAIRE_DELETE_SUCCESS:
            return { loading: false, success: true }
        case STAGIAIRE_DELETE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const stagiaireUpdateReducer = (state = { stagiaire: {} }, action) => {
    switch (action.type) {
        case STAGIAIRE_UPDATE_REQUEST:
            return { loading: true }
        case STAGIAIRE_UPDATE_SUCCESS:
            return { loading: false, success: true }
        case STAGIAIRE_UPDATE_FAIL:
            return { loading: false, error: action.payload }
        case STAGIAIRE_UPDATE_RESET:
            return {
                stagiaire: {}
            }
        default:
            return state
    }
}